import React, { ReactNode } from 'react'
import CreationToolUploadField from '../../types/upload-field'
import { Subtitle } from '../typography'
import Icon from './field-icon'

type Props = {
    children?: ReactNode
    className?: string
    field: CreationToolUploadField
}

const CreationUploadFieldTitle = ({ children, className, field }: Props) => {
    const title = CreationToolUploadField.title(field)
    return (
        <Subtitle className={className}>
            <Icon field={field} />
            {title}
            {children}
        </Subtitle>
    )
}

export default CreationUploadFieldTitle
